<template>
    <basic-card>
        <template slot="header">
            {{header}}
        </template>
        <div v-html="contentHTML"></div>
    </basic-card>
</template>

<script>
    import BasicCard from "../../layout/BasicCard";
    export default {
        name: "StaticTextWidget",
        props: {
            header: String,
            contentHTML: String
        },
        components: {BasicCard}
    }
</script>

<style scoped>

</style>